import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { ICountryCode } from "../address/address.models";

export const countryCodeAdapter: EntityAdapter<ICountryCode> = createEntityAdapter<ICountryCode>({
	selectId: country => country.countryAbbr
});